import { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import LinkButton from "../../components/PhysicalCard/LinkButton";
import PCRightContainer from "../../components/PhysicalCard/PCRightContainer";
import PCTable from "../../components/PhysicalCard/PCTable";
import { ToastMessage } from "../../components/ToastMessage";
import { Colors, Text } from "../../config/Constants";
import { getFormattedCardList } from "../../helper";
import { getCardList, getCardQR } from "../../services/cardsService";
const LIMIT = 10;

const PhysicalCard = () => {
  const [responseData, setResponseData] = useState<any>([]);
  const [totalCardList, setTotalCardList] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [qrImage, setQRImage] = useState("");
  const [isTableDataLoading, setTableDataLoading] = useState(false);

  const handleRefresh = () => {
    fetchCardList(currentPage, LIMIT);
  };

  const handleQRGeneration = async () => {
    try {
      let { data } = await getCardQR();
      if (data.code === 200) {
        setQRImage(`${process.env.REACT_APP_API_BASEURL}${data.data.imgurl}`);
        const link = document.createElement("a");
        link.href = `${process.env.REACT_APP_API_BASEURL}${data.data.imgurl}`;
        document.body.appendChild(link);
        link.click();
      }
    } catch (err: any) {
      if (navigator.onLine) {
        toast.error(err.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message={Text.offlineMessage}
            subMessage={Text.internetDisconnected}
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
  };

  const fetchCardList = async (activePage: number, limitCount: number) => {
    setTableDataLoading(true);
    try {
      const { data } = await getCardList(activePage, limitCount);
      let formattedResponse = getFormattedCardList(data.data);
      setResponseData(formattedResponse);
      setTableDataLoading(false);
      setTotalCardList(data.count);
    } catch (error: any) {
      setTableDataLoading(false);
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message={Text.offlineMessage}
            subMessage={Text.internetDisconnected}
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchCardList(page, LIMIT);
  };

  return (
    <PhysicalCardPageContainer>
      <PhysicalCardContainer>
        <StyledPageHeader>{Text.physicalCardHeader}</StyledPageHeader>
        <QRCodeContainer>
          {/* <PCLeftContainer /> */}
          <PCRightContainer onGenerate={handleQRGeneration} source={qrImage} />
        </QRCodeContainer>
      </PhysicalCardContainer>
      <TableWrapper>
        <ActionWrapper>
          <LinkButton onRefresh={handleRefresh} />
        </ActionWrapper>
        <PCTable
          onPageChange={(page) => handlePageChange(page)}
          totalData={totalCardList}
          currentPage={currentPage}
          rowsPerPage={LIMIT}
          data={responseData}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
    </PhysicalCardPageContainer>
  );
};
const ActionWrapper = styled.div`
  text-align: right;
  margin-bottom: 1rem;
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const PhysicalCardPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  @media only screen and (max-width: 768px) {
    gap: 2rem;
  }
`;

const PhysicalCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  > div {
    width: 50%;
  }
  @media only screen and (max-width: 768px) {
    gap: 0.25rem;
    > div {
      width: 100%;
    }
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  font-weight: 500;
  line-height: 1.75rem;
  padding-bottom: 1.25rem;
  color: ${Colors.black};
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default PhysicalCard;
